export default "__VITE_ASSET__BnoFwJPG__"